import React from "react";
import { withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { get, map, filter } from "lodash";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import DatePicker from "../../Common/DatePicker";
import FormSection from "../../Common/FormSection";
import { fetchGet } from "../../../api/fetch";
import { calendarViews, HSP } from "../../../constants/common";
import Reservation from "./Reservation";
import { formatDate, setToMidnight } from "../../../utils/date";
import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";
import { getLov } from "../../../utils/lov";

const styles = {
  container: {},
  arrowContainer: {
    width: "30px",
    height: "30px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  todayButton: {
    color: colors.primary,
    cursor: "pointer",
    textTransform: "uppercase",
    fontWeight: 500,
  },
  radio: {
    color: colors.black54,
    fontSize: "14px !important",
  },
};

const SchedulerFiltersMDC = (props) => {
  const {
    classes,
    companies,
    calendarView,
    setCalendarView,
    startDate,
    setStartDate,
    filters,
    handleFiltersChange,
    language,
    type,
  } = props;
  const [scheduleTypes, setScheduleTypes] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [typeReservation, setType] = React.useState();
  const [typeId, setTypeId] = React.useState();
  const [eventTypes, setEventTypes] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    const getEventTypes = async () => {
      try {
        const schedule_types = await fetchGet("schedule_type_events");
        return schedule_types;
      } catch (e) {
        console.log(e.message);
      }
    }
    getEventTypes().then(data => {
      const tempEvents = []

      for (let index in data) {
        var event = data[index]
        if (!(event["name_en"].includes("Arrival") || event["name_en"].includes("Departure"))) {
          tempEvents.push(event)
        }
      }
      setEventTypes(tempEvents)
    }).catch(
      error => {
        console.log(error)
      }
    )
  }, [])

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line
  }, [type]);

  const fetchLov = async () => {
    try {
      let scheduleTypes = await getLov("scheduleTypes");
      scheduleTypes = filter(
        scheduleTypes,
        (t) =>
          t.parent_schedule_type_id === (type === HSP ? 1 : 2) &&
          t.is_schedulable
      );
      //Fetch Roles here.
      setScheduleTypes(scheduleTypes);
    } catch (e) {
      console.log(e);
    }
  };

  const changePeriod = (prev) => {
    let msAmount;
    if (calendarView === calendarViews.weekly) {
      msAmount = 604800000;
    } else if (calendarView === calendarViews.daily) {
      msAmount = 86400000;
    }
    if (prev) {
      setStartDate(new Date(startDate.getTime() - msAmount));
    } else {
      setStartDate(new Date(startDate.getTime() + msAmount));
    }
  };

  const handleDateSelect = (name, date) => {
    const day = new Date(date).getDay();
    if (calendarView === calendarViews.daily) {
      setStartDate(new Date(date));
    } else if (calendarView === calendarViews.weekly) {
      setStartDate(new Date(new Date(date).getTime() - day * 86400000));
    }
  };

  const formatDateLabel = (startDate) => {
    if (calendarView === calendarViews.weekly) {
      const start = new Date(startDate);
      const end = new Date(start.getTime() + 604800000);
      return `${formatDate(start, "DD/MM")} - ${formatDate(end, "DD/MM")}`;
    } else if (calendarView === calendarViews.daily) {
      const start = new Date(startDate);
      return `${formatDate(start, "DD/MM")}`;
    }
  };

  const RenderDropDownItems = () => {
    return (eventTypes.map((event, i) => {
      return (
        <MenuItem
          key={i}
          onClick={() => { setType(event["name_en"].toLowerCase()); setOpen(true); setTypeId(event.id); handleClose(); }}
        >
          {I18n.get(event["name_en"])}
        </MenuItem>
      )
    })
    )
  }

  return (
    <Grid
      item
      container
      data-test="scheduler-filters-component"
      className={classes.container}
    >
      <Dialog open={open}>
        <Reservation type={typeReservation} setOpen={setOpen} filters={filters} handleFiltersChange={handleFiltersChange} typeId={typeId} tabsOriginal={typeId == 12 ? { // typeId = 12 is switch
          0: [3, '0', false, 0, 0, [], "", type, "", "", [], [], "", false, false, 0, '0', false, 0, '0', 15, '0', 13, "", ""],
          1: [3, '0', false, 0, 0, [], "", type, "", "", [], [], "", false, false, 0, '0', false, 0, '0', 15, '0', 7, "", ""],
          2: [3, '0', false, 0, 0, [], "", type, "", "", [], [], "", false, false, 0, '0', false, 0, '0', 15, '0', 8, "", ""],
          3: [3, '0', false, 0, 0, [], "", type, "", "", [], [], "", false, false, 0, '0', false, 0, '0', 15, '0', 14, "", ""] //if switch then hard coded drop and pick up events.
        } : {
          0: [3, '0', false, 0, 0, [], "", type, "", "", [], [], "", false, false, 0, '0', false, 0, '0', 15, '0', 13, "", ""],
          1: [3, '0', false, 0, 0, [], "", type, "", "", [], [], "", false, false, 0, '0', false, 0, '0', 15, '0', typeId, "", ""],
          2: [3, '0', false, 0, 0, [], "", type, "", "", [], [], "", false, false, 0, '0', false, 0, '0', 15, '0', 14, "", ""] //if not a switch. pass in normal tab values
        }
        } />
      </Dialog>
      <Box className="flexCenter" style={{ width: "150px" }}>
        <div>
          <Button
            style={{ backgroundColor: "#5f00a0", color: "white" }}
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <img
              src={images.plusIconWhite}
              alt="plus"
              style={{ marginRight: "5px", position: "relative", top: "-2px" }}
            />
            {I18n.get("reservation")}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <RenderDropDownItems />
          </Menu>
        </div>

      </Box>
      <Box style={{ marginRight: "30px" }}>
      </Box>
      <Box style={{ width: "170px", marginRight: "30px" }}>
        <FormSection
          formValue={[get(filters, ["site"]) || "1"]}
          setFormValue={handleFiltersChange}
          title={"site"}
          id={"site"}
          type="select"
          options={{
            categories: true,
            options: map(companies, (c) => ({
              ...c,
              options: get(c, ["sites"]),
            })),
          }}
        />
      </Box>
      <Box style={{ width: "170px", marginRight: "30px" }}>
        <FormSection
          formValue={get(filters, ["scheduleType"]) || []}
          setFormValue={handleFiltersChange}
          title2={I18n.get("role")}
          id={"scheduleType"}
          type="select"
          options={{
            nullForAll: true,
            selectAll: true,
            multipleSelect: true,
            options: map(scheduleTypes, (item) => ({
              id: get(item, ["id"]),
              name: get(item, ["name", language]),
            })),
          }}
        />
      </Box>
      <Box className="flexCenter">
        <span
          className={classes.arrowContainer}
          onClick={() => changePeriod(true)}
        >
          <img
            src={images.leftArrowLight}
            alt="left-arrow"
            data-test="scheduler-filters-previous-arrow"
          />
        </span>
        <span
          className={classes.arrowContainer}
          onClick={() => changePeriod(false)}
        >
          <img
            src={images.rightArrowLight}
            alt="right-arrow"
            data-test="scheduler-filters-next-arrow"
          />
        </span>
      </Box>
      <Grid container direction="column" style={{ width: "156px" }}>
        <Grid item style={{ textAlign: "right" }}>
          <span
            className={classes.todayButton}
            onClick={() => handleDateSelect(null, setToMidnight(Date.now()))}
          >
            {I18n.get("dashboard_today")}
          </span>
        </Grid>
        <DatePicker
          name="startDate"
          value={startDate}
          onChange={handleDateSelect}
          dateOnly
          formatLabel={formatDateLabel}
        />
      </Grid>
      <Box style={{ width: "92px", marginLeft: "9px" }}>
        <FormSection
          formValue={[calendarView]}
          setFormValue={(id, index, value) => { setCalendarView(value); }}
          title2="‎‎ "
          id={"view"}
          type="select"
          options={{
            options: map(calendarViews, (view) => ({
              id: view,
              name: I18n.get(`common_${view}`),
            })),
          }}
        />
      </Box>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: get(state, ["user", "companies"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(SchedulerFiltersMDC));
